import React from 'react'
import Responsivo from './../images/responsivo'
import Acesso from './../images/acesso'
import Perfil from './../images/perfil'
import Performance from './../images/performance'


const news = [
    {
      title: 'Design Responsivo',
      key: 'responsivo',
      img: <Responsivo />,
      icon: 'far fa-mobile-alt',
      description: 'Interface adaptável para dispositivos mobile, com acesso simultâneo, garantindo mais praticidade nas vendas.'
    },
    {
        title: 'Acesso Simultâneo',
        key: 'acesso',
        img: <Acesso />,
        icon: 'far fa-sync',
        description: 'A partir do compartilhamento de dados, é possível acessar as informações do sistema antigo no TagPlus 2.0.'
      },
      {
        title: 'Ações no perfil de acesso',
        key: 'perfil',
        img: <Perfil />,
        icon: 'fal fa-lock-alt',
        description: 'Você pode definir quais tipos de ações, restrições e permissões específicas dentro de cada módulo.'
      },
      {
        title: 'Performance de alto nível',
        key: 'performance',
        img: <Performance />,
        icon: 'far fa-bolt',
        description: 'Devido aos recursos modernos de programação, o TagPlus 2.0 está mais rápido e prático.'
      },
    
  ]
  export {
    news 
  }